import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';

import { useMediaQuery } from '@ps-design-system/lib/hooks/use-media-query';

import UploaderLayout from '../../_v2/features/app-uploader/components/UploaderLayout';

import { UploaderPageProvider } from '../../_v2/features/app-uploader/context/UploaderPageContext';
import { UploadModalProvider } from '../../_v2/features/app-uploader/context/UploadModalContext';

const UploaderContainer = ({ params, intl, router }) => {
  const isMobile = useMediaQuery('(max-width: 992px)');

  return (
    <UploadModalProvider>
      <UploaderPageProvider
        params={params}
        intl={intl}
        router={router}
        isMobile={isMobile}
      >
        <UploaderLayout/>
      </UploaderPageProvider>
    </UploadModalProvider>
  );
};

UploaderContainer.propTypes = {
  params: PropTypes.object,
  intl: intlShape,
  router: PropTypes.shape({
    push: PropTypes.func.isRequired
  })
};

export default injectIntl(UploaderContainer);
